import { supabase } from '@shared/supabase/client';

/**
 * Flip the account type (business/advertiser ⇄ creator) BEFORE any claim is
 * committed. The RPC (switch_account_type) rewrites the role + access_status and
 * clears abandoned pending claims; we then refresh the session and hard-navigate
 * so AuthContext re-initialises cleanly with the new role (a react-router navigate
 * races the async token pickup).
 */
export async function switchAccountType(type: 'creator' | 'advertiser'): Promise<void> {
  const { error } = await supabase.rpc('switch_account_type', { p_type: type });
  if (error) throw error;
  await supabase.auth.refreshSession();
  window.location.assign(type === 'creator' ? '/provider' : '/customer');
}
